(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["divaderme-ritual"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dd-aroma-drift')) {
  customElements.define('dd-aroma-drift', class extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-played') || matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.setAttribute('data-played', '');
        this.observer.disconnect();
      }, { threshold: 0.45 });
      this.observer.observe(this.parentElement);
    }
    disconnectedCallback() { if (this.observer) this.observer.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh_logo_slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('divaderme-press-strip')) {
    customElements.define('divaderme-press-strip', class extends HTMLElement {
      connectedCallback() {
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.applyMotion = () => {
          this.toggleAttribute('data-animate', !this.motion.matches);
        };
        this.style.setProperty('--dd-press-duration', (Number(this.dataset.duration) || 32) + 's');
        this.motion.addEventListener('change', this.applyMotion);
        this.applyMotion();
      }
      disconnectedCallback() {
        this.motion?.removeEventListener('change', this.applyMotion);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
